<template>
    <UProgress v-model="value" v-if="loading" size="sm"/>
</template>

<script setup>
const props = defineProps({
    loading: {
        type: Boolean,
        default: false
    }
})

const value = ref(null)
</script>